'use es6';

import { combineReducers } from 'redux';
import SeamlessImmutable from 'seamless-immutable';
import { RAW_ASSET_EDITOR_OPTIONS_SAVE_ACCORDION_STATE } from 'DesignData/actions/ActionTypes';

function accordionStatesById(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case RAW_ASSET_EDITOR_OPTIONS_SAVE_ACCORDION_STATE:
      {
        const {
          rawAssetId,
          key,
          isOpen
        } = action;
        if (!(rawAssetId && key)) return state;
        state = SeamlessImmutable.setIn(state, [rawAssetId, key], isOpen);
        return state;
      }

    default:
      {
        return state;
      }
  }
}

export default combineReducers({
  accordionStatesById
});